import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    margin: '1rem 3rem',
    paddingRight: '1.5rem'
  },

  messages: {
    width: '100%',
    textAlign: 'center',
    cursor: 'default'
  },

  title: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: theme.size.sm,
    marginBottom: '1rem',
    alignItems: 'flex-start'
  },

  link: {
    marginRight: '1rem',
    cursor: 'pointer',
    color: theme.palette.primary.main
  },

  retryMsgs: {
    margin: '0.5rem 1.25rem'
  },

  buttonContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center'
  }
}))

export default useStyles
